<template>
    <div>
        <!-- Loading state -->
        <div v-if="loading" class="loading-container">
            Notiek datu ielāde...
        </div>

        <!-- Error state -->
        <div v-else-if="error" class="error-container">
            {{ error }}
        </div>

        <!-- Dynamic template rendering -->
        <component v-else :is="selectedTemplate" :business-slug="businessSlug" :business="businessData"
            :services="services" :providers="providers" :addons="addons" :is-rescheduling="isRescheduling"
            :existing-appointment="existingAppointment" :appointment-id="appointmentId"
            @book-appointment="handleBooking" @reschedule-appointment="handleReschedule" />
    </div>
</template>

<script>
import MinimalistTemplate from './MinimalistTemplate.vue'
//import ProfessionalTemplate from './ProfessionalTemplate.vue'

export default {
    name: 'BookingPage',
    components: {
        MinimalistTemplate,
        //ProfessionalTemplate,
    },
    props: {
        businessSlug: {
            type: String,
            required: true
        },
        appointmentId: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            loading: true,
            error: null,
            businessData: null,
            services: [],
            providers: [],
            addons: [],
            existingAppointment: null,
            isRescheduling: false
        }
    },
    computed: {
        selectedTemplate() {
            if (!this.businessData) return null;

            // Map template choice to component
            const templateMap = {
                'minimalist': MinimalistTemplate,
               //'professional': ProfessionalTemplate,
            };

            return templateMap[this.businessData.template] || MinimalistTemplate;
        }
    },
    created() {
        this.checkRescheduleMode();
        this.fetchBusinessData();
    },
    methods: {
        async fetchBusinessData() {
            try {
                this.loading = true;

                const response = await this.$http.get(`/api/businesses/${this.businessSlug}/booking-data/`);

                if (response?.data?.code === 'ok') {
                    this.services = response.data.data?.services || [];
                    this.providers = response.data.data?.providers || [];
                    this.addons = response.data.data?.addons || [];

                    // Create a basic business data object
                    this.businessData = {
                        id: response.data.data?.businessId,
                        name: response.data.data?.businessName || '',
                        description: response.data.data?.description || '',
                        template: 'minimalist',
                        colorScheme: response.data.data?.colorScheme,
                        avatar: response.data.data?.avatar,
                        shortDescription: response.data.data?.shortDescription,
                        instagramLink: response.data.data?.instagramLink,
                        facebookLink: response.data.data?.facebookLink,
                        websiteLink: response.data.data?.websiteLink
                    };
                } else {
                    throw new Error('Invalid response format');
                }
            } catch (error) {
                this.error = 'Failed to load booking page';
                console.error('Error fetching business data:', error);
            } finally {
                this.loading = false;
            }
        },
        async handleBooking(appointmentDetails) {
            try {
                console.log(appointmentDetails)
                return {
                    success: true
                };
            } catch (error) {
                console.error('Error creating booking:', error);
                return {
                    success: false,
                    error: 'Neizdevās saglabāt pierakstu. Lūdzu mēģiniet vēlreiz.'
                };
            }
        },
        checkRescheduleMode() {
            // Check if we're in reschedule mode
            const appointmentQuery = this.$route.query.appointment;
            if (appointmentQuery && this.appointmentId) {
                this.isRescheduling = true;
                try {
                    this.existingAppointment = JSON.parse(appointmentQuery);
                } catch (error) {
                    console.error('Error parsing appointment data:', error);
                }
            }
        },
        async handleReschedule(rescheduleDetails) {
            try {
                const response = await this.$http.put(`/api/public/appointments/${this.appointmentId}/reschedule`, {
                    newDate: rescheduleDetails.date,
                    newTime: rescheduleDetails.time,
                    newProviderId: rescheduleDetails.provider.id,
                    token: this.$route.query.token
                });

                if (response.data.code === 'ok') {
                    return {
                        success: true,
                        message: 'Pieraksts veiksmīgi pārplānots!',
                        newToken: response.data.data?.newToken 
                    };
                }
            } catch (error) {
                console.error('Error rescheduling:', error);
                return {
                    success: false,
                    error: 'Neizdevās pārplānot pierakstu. Lūdzu mēģiniet vēlreiz.'
                };
            }
        }
    }
}
</script>